export var props = {
  index: {
    type: [Number, String]
  }
};